import React, { useEffect, useState } from "react";
import "./NewCitypageBlue.css";
import HomeService from "../../Services/HomeService";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import cityImg from "../../Images/city-skyline.jpg";
import heroImg from "../../Images/hero-villa.jpg";
import towerImg from "../../Images/property-tower.jpg";
import interiorImg from "../../Images/apartment-interior.jpg";

import AdvertisingBanner from "./AdvertisingBanner";
import ExploreTopCities from "./ExploreTopCities";
import LocationInsig from "../WinnersHome/LocationInsig";
import AboutCommunity from "./AboutCommunity";
import Header2 from "../../Layout/Header2";
import { WinnersBannerBlue } from "../WinnersHome/WinnerBlueLan/WinnerBannerBlue";
import { WinnersCitiesBlue } from "../WinnersHome/WinnerBlueLan/WinnersCitiesBlue";

function NewCitypageBlue() {
  const [cityDetails, setCityDetails] = useState({});
  const [reelsForCity, setReelsForCity] = useState([]);
  const location = useLocation();
  const id = location?.state?.id || "";
  const navigate = useNavigate();

  const fetchCityDetilsById = async () => {
    try {
      const res = await HomeService.getCityDetailsById(id);
      if (res?.status) {
        setCityDetails(res?.data);
      } else {
        console.log(res?.data);
      }
      console.log("CITY DETAILS BLUE", res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReelsByCityId = async () => {
    try {
      const res = await HomeService.getReelsByCityId(id);
      if (res?.status) {
        setReelsForCity(res?.data);
      } else {
        console.log(res?.data);
      }
      console.log("REELS DETAILS BLUE", res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCityDetilsById();
    fetchReelsByCityId();
    window.scroll(0, 0);
  }, [id]);

  const [index, setIndex] = useState(0);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % 3);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 10000);
    return () => clearInterval(timer);
  }, []);

  const cityData = [
      {
        name: "Gurgaon",
        tag: "NCR",
        count: "1240",
        img: cityImg,
      },
      {
        name: "Lucknow",
        tag: "UP",
        count: "980",
        img: heroImg,
      },
      {
        name: "Noida",
        tag: "NCR",
        count: "1560",
        img: towerImg,
      },
      {
        name: "Dwarka",
        tag: "Delhi",
        count: "890",
        img: interiorImg,
      },
    ];

  return (
    <div className="citypage_container_blue">
      <div style={{ position: "sticky", top: "0px", zIndex: "1000" }}>
        <Header2 />
      </div>
      
      <div
        className="hero-container_blue"
        style={{
          background: cityDetails?.firstSection?.image 
            ? `linear-gradient(to right, rgba(0, 0, 0, 0.75), rgba(0, 52, 102, 0.45)), url(${cityDetails?.firstSection?.image}) center/cover no-repeat`
            : "linear-gradient(135deg, var(--ws-blue-primary), var(--ws-blue-secondary))",
        }}
      >
        <div className="hero-content_blue">
          {cityDetails?.firstSection?.mainTag && (
            <span className="tag_blue">{cityDetails?.firstSection?.mainTag}</span>
          )}
          <h1>
            {cityDetails?.firstSection?.header
              ?.split(" ")
              .slice(0, 2)
              .join(" ")}{" "}
            <span className="highlight_blue">
              {cityDetails?.firstSection?.header
                ?.split(" ")
                .slice(2, 4)
                .join(" ")}{" "}
            </span>
            {cityDetails?.firstSection?.header?.split(" ").slice(4).join(" ")}
          </h1>
          <p className="sub-text_blue">
            {cityDetails?.firstSection?.descriptions?.map((e, i) => {
              return <span key={i}>{e} • </span>;
            })}
          </p>

          <div className="buttons_blue">
            <button
              className="primary_blue"
              onClick={() => {
                navigate("/profile");
              }}
            >
              Register Now →
            </button>
            <button className="secondary_blue">Learn More</button>
          </div>

          <div className="features_blue">
            {cityDetails?.firstSection?.tags?.map((e, i) => {
              return (
                <div key={i} className="feat_icon_blue">
                  <span className="feat_icon_span_blue">
                    <img
                      src={e?.icon}
                      style={{
                        height: "16px",
                        width: "16px",
                        display: "block",
                        margin: "auto",
                      }}
                      alt=""
                    />
                  </span>{" "}
                  {e?.content}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="spc-wrp-for-city_blue">
        {/* <AdvertisingBanner /> */}
        <WinnersBannerBlue />
      </div>

      {/* <ExploreTopCities /> */}
       <WinnersCitiesBlue
              eyebrow="Popular Cities"
              title="Explore Top Locations"
              description="Discover premium properties in India's fastest growing cities."
              cities={cityData}
            />
      <LocationInsig />

      {/* 4th section start */}
      <div className="problems-section_blue">
        <div className="problem_div_blue">
          <h2 className="main-title_blue">
            <span className="blue-text_blue">
              <span>
                {cityDetails?.fourthSection?.heading
                  ?.split(" ")
                  .slice(0, 4)
                  .join(" ")}{" "}
              </span>
              {cityDetails?.fourthSection?.heading
                ?.split(" ")
                .slice(4).join(" ")}
            </span>
          </h2>
          <p className="subtitle_blue">
            {cityDetails?.fourthSection?.subHeading}
          </p>
          <div className="problemscards_sec_blue">
            {cityDetails?.fourthSection?.sections?.map((item) => (
              <div key={item.id} className="problem-card_blue">
                <div className="icon_blue">
                  <img
                    style={{ height: "30px", width: "30px" }}
                    src={item?.icon}
                    alt=""
                  />
                </div>
                <div className="problem_para_blue">
                  <h4>{item?.header}</h4>
                  <p>{item?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 6th section start */}
      <div className="problems-section2_blue">
        <h2 className="main-title22_blue">
          {cityDetails?.fifthSection?.heading}
        </h2>
        <p className="subtitle22_blue">
          {cityDetails?.fifthSection?.desc}
        </p>
        <div className="problemscards_sec_blue">
          {cityDetails?.fifthSection?.sections?.map((item) => (
            <div key={item.id} className="problem-card22_blue">
              <div className="icon_blue">
                <img
                  style={{ height: "30px", width: "30px" }}
                  src={item?.icon}
                  alt=""
                />
              </div>
              <div className="problem_para22_blue">
                <h4>{item?.heading}</h4>
                <p>{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 7th section start */}
      <div className="howitworks-section_blue">
        <div className="stats-container_blue">
          {cityDetails?.seventhSection?.counts?.map((item, index) => (
            <div key={index} className="stat-box_blue">
              <h2>{item?.heading}</h2>
              <p>{item?.subHeading}</p>
            </div>
          ))}
        </div>
        <div className="how-content_blue">
          <div className="contant_title_blue">
            <h2 className="titleh2_blue">
              {cityDetails?.seventhSection?.midHeading}
            </h2>
            <p className="subtitle_blue">
              {cityDetails?.seventhSection?.midSubHeading}
            </p>
          </div>

          <div className="steps-container_blue">
            {cityDetails?.seventhSection?.works?.map((step, index) => (
              <div key={index} className="step-card_blue">
                <div className="step-icon_blue">
                  <img
                    style={{ height: "30px", width: "30px" }}
                    src={step?.icon}
                    alt=""
                  />
                </div>
                <h4>{step?.heading}</h4>
                <p>{step?.subheading}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="gurgaon-lead_blue">
          <div className="gurgaon-under_blue">
            <div className="gurgaon-under_left_blue">
              <div
                className="gargaon_card1_blue"
                style={{
                  background: cityDetails?.thirdSection?.image
                    ? `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)), url(${cityDetails?.thirdSection?.image}) center/cover no-repeat`
                    : "var(--ws-blue-primary)",
                }}
              >
                <h2>Since 2000</h2>
                <p>serving the Industry</p>
              </div>
            </div>
            <div className="gurgaon-under_right_blue">
              <div className="garga_h2_blue">
                <h2 className="garga_h2_h2_blue">
                  <span>
                    {cityDetails?.thirdSection?.heading
                      ?.split(" ")
                      .slice(0, 2)
                      .join(" ")}{" "}
                  </span>
                  {cityDetails?.thirdSection?.heading
                    ?.split(" ")
                    .slice(2)
                    .join(" ")}
                </h2>
                <div className="garga_para_blue">
                  <p>{cityDetails?.thirdSection?.desc}</p>
                </div>
                <div className="garga_list_blue">
                  {cityDetails?.thirdSection?.points?.map((e, i) => {
                    return (
                      <p key={i} className="garga_list_p_blue">
                        <img
                          style={{ height: "20px", width: "20px" }}
                          alt={i}
                          src={e?.icon}
                        />{" "}
                        {e?.content}
                      </p>
                    );
                  })}
                </div>
              </div>
              <button
                onClick={() => {
                  navigate("/aboutus");
                }}
                className="gargabtn_blue"
              >
                Learn More About Us
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 8th section start */}
      <div className="mobile_section_blue">
        <div className="mange_section_left_blue">
          <h2 className="mange_h1_blue">{cityDetails?.eighthSection?.heading}</h2>
          <h2 className="mange_h2_blue">On The Go</h2>
          <p className="mange_para_blue">
            {cityDetails?.eighthSection?.description}
          </p>
          <div className="img_blue">
            <a href={cityDetails?.eighthSection?.playStore}>
              <img src="gicon.png" alt="Google Play" />
            </a>
            <a href={cityDetails?.eighthSection?.appStore}>
              <img src="aicon.jpg" alt="App Store" />
            </a>
          </div>
        </div>
        <div className="mange_section_right_blue">
          <img
            src={cityDetails?.eighthSection?.image}
            alt="Mobile App"
          />
        </div>
      </div>

      {/* footer section */}
      <footer className="footer-section_blue">
        <div className="footer-cta_blue">
          <h2>{cityDetails?.ninethSection?.heading}</h2>
          <p>{cityDetails?.ninethSection?.desc}</p>

          <button
            className="register-btn_blue"
            onClick={() => {
              navigate("/profile");
            }}
          >
            Register Now
          </button>
        </div>

        <div className="footer-main_blue">
          <div className="footer-left_blue">
            <h3 className="brand_blue">
              TheWinners2 <span>.in</span>
            </h3>
            <p className="brand-text_blue">
              Gurugram’s most powerful real estate data & broker platform.
              Helping brokers close deals faster with verified data.
            </p>

            <div className="social-icons_blue">
              <img src="fb.webp" alt="Facebook" />
              <img src="twitter.png" alt="Twitter" />
            </div>
          </div>

          <div className="footer-links_blue">
            <h4>Quick Links</h4>
            <ul>
              <li>Home</li>
              <li>Services</li>
              <li>About Us</li>
              <li>Contact</li>
            </ul>
          </div>

          <div className="footer-legal_blue">
            <h4>Legal</h4>
            <ul>
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom_blue">
          <p>© 2025 TheWinners2.in. All rights reserved.</p>
          <p>Designed for Broker Success.</p>
        </div>
      </footer>
    </div>
  );
}

export default NewCitypageBlue;
